import React from "react";
import "../styles/Contact.css";
import DecorativeImage from "../images/telephone.png";

const Contact = () => {
  return (
    <section className="contact-section">
      {/* Decorative Image */}
      <img src={DecorativeImage} alt="Decorative" className="contact-decoration" />
      <div className="contact-container">
        <h2 className="contact-heading">Get in Touch</h2>
        <p className="contact-subheading">
          Have questions, feedback, or want to collaborate? We'd love to hear from you!
        </p>
        <div className="contact-content">
          {/* Contact Form */}
          <form className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" name="name" placeholder="Your Name" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" placeholder="Your Email" required />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" placeholder="Your Message" rows="4" required />
            </div>
            <button type="submit" className="submit-button">Send Message</button>
          </form>

          {/* Contact Details */}
          <div className="contact-details">
            <h3>Contact Us</h3>
            <p><strong>Email:</strong> m2aslam@gmail.com</p>
            <p><strong>Phone:</strong> +92 300 8427 613</p>
            <p><strong>Address:</strong> 123 Qibla Avenue, Knowledge City</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
